<template>
  <div class="flex col-row items-center bg-white my-2 md:h-24 cursor-pointer" :class="{'bg-yellow-200': userParam.verified_at}">
    <div class="w-1/4 md:w-1/12 justify-start">
      <vs-avatar :text="userParam.dataGeneral.displayName" size="large" :src="userParam.dataGeneral.avatar"></vs-avatar>
    </div>

    <div class="w-1/3 flex flex-col">
      <div class="w-full flex items-center">
        <i class="mr-2 flag-icon" :class="currencyFlagIcon" v-if="currencyFlagIcon"/>
        <span class="font-medium truncate">
        {{ userParam.dataGeneral.displayName }}
      </span>
      </div>

      <div class="w-full flex text-left" @click.stop>
      <span class="text-xs md:text-base truncate">
        {{ userParam.dataGeneral.email }}
      </span>
      </div>
    </div>

    <div class="w-1/3 flex flex-col">
      <div class="w-full flex text-left">
        <span class="text-xs md:text-base truncate">@{{ userParam.dataGeneral.nickName }}</span>
      </div>

      <div class="w-full flex text-left">
        <p class="text-base">{{ userParam.roles | rolesToStr }}</p>
      </div>
    </div>

    <div class="w-auto flex space-x-1" v-if="editButtons">
      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="editData"/>
      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click.stop="deleteData"/>
    </div>
  </div>
</template>

<script>
import {getLangByValue} from "@/helpers/lists";

export default {
  name: "UserListItem",
  props: {
    userParam: {
      type: Object,
      required: true
    },
    editButtons: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currencyFlagIcon() {
      if (this.userParam.dataInfo.currency) {
        return getLangByValue(this.userParam.dataInfo.currency).icon
      }

      return null;
    }
  },
  methods: {
    editData () {
      this.$emit('click', this.userParam.id);
    },
    deleteData() {
      this.$emit('removeUser', this.userParam.id);
    }
  }
}
</script>

<style scoped>

</style>
